import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChartResponderCell, SimpleChartData } from '@app/app/shared/components/carts/SimpleChartData';

@Component({
  selector: 'ptl-choice-results-table-preview',
  templateUrl: './choice-results-table-preview.component.html',
  styleUrls: ['./choice-results-table-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChoiceResultsTablePreviewComponent {
  @Input() rows: SimpleChartData[] = [];
  @Input() variant: 'legacy' | 'v3' = 'legacy';

  get columns(): ChartResponderCell[] {
    const seen = new Set<string>();
    return this.rows
      .flatMap((r) => r.responders ?? [])
      .filter((responder) => {
        if (seen.has(responder.id)) return false;
        seen.add(responder.id);
        return true;
      });
  }

  trackRow = (_: number, r: SimpleChartData) => r.label;
  trackCol = (_: number, c: ChartResponderCell) => c.id;

  picked(row: SimpleChartData, col: ChartResponderCell): boolean {
    return !!row.responders?.find((c) => c.id === col.id)?.selected;
  }

  hasPicked(row: SimpleChartData) {
    return this.columns.some((c) => this.picked(row, c));
  }
}
